import { Injectable } from '@angular/core';

import { delay, Observable, of } from 'rxjs';

import { ExchangeApiService } from '@kr/components/exchange/api/exchange-api.service';
import { mockExchangeEstimateRes } from '@kr/components/exchange/mocks/exchange-estimate-res.mock';
import { mockExchangeRes } from '@kr/components/exchange/mocks/exchange-res.mock';
import { ExchangeEstimateRes, ExchangeRes } from '@kr/components/exchange/models';

@Injectable()
export class ExchangeApiMockService extends ExchangeApiService {
  override exchange(): Observable<ExchangeRes> {
    return of(mockExchangeRes).pipe(delay(500));
  }

  override exchangeEstimate(): Observable<ExchangeEstimateRes> {
    return of(mockExchangeEstimateRes).pipe(delay(500));
  }
}
